import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=af147856"
import script from "./InventoryCard.vue?vue&type=script&lang=js"
export * from "./InventoryCard.vue?vue&type=script&lang=js"
import style0 from "./InventoryCard.vue?vue&type=style&index=0&id=af147856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports